var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("dialogs-base", {
    attrs: { show: _setup.dialog, "max-width": _vm.maxWidth },
    on: {
      "update:show": function ($event) {
        _setup.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-card",
              { attrs: { color: "primary", dark: "" } },
              [
                _c(
                  "v-card-text",
                  [
                    _vm._v(" " + _vm._s(_vm.label) + " "),
                    _c("v-progress-linear", {
                      staticClass: "mb-0",
                      attrs: { indeterminate: "", color: "white" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }